import { type ClassValue, clsx } from "clsx";
import { format } from "date-fns";
import { twMerge } from "tailwind-merge";

export { renderIcon, getMarkerIconPath } from './inventory/render-inventaire-icon';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isNotNullOrEmpty(value: any): boolean {
  return value !== null && value !== undefined && value !== '' && value !== 'null';
}


/**
 * Format a date to a readable string
 */
export function formatDate(date: Date): string {
  if (!date) return format(new Date(), 'dd/MM/yyyy');
  try {
    return format(date, 'dd/MM/yyyy');
  } catch (error) {
    console.error("Error formatting date:", error);
    return format(new Date(), 'dd/MM/yyyy');
  }

}

export function formatDateOnly(date: Date): string {

  try {
    const formatter = new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);

    return formatter;
  } catch (error) {
    console.error("Error formatting date:", error);
    return date.toString();
  }
}

export const isBetweenDates = (date: Date, startDate: Date, endDate: Date): boolean => {
  return date.getTime() >= startDate.getTime() && date.getTime() <= endDate.getTime();
}